<template>
  <v-layout class="mb-3" justify-center>
    <v-flex xs12 sm8 md6>
      <v-text-field
        v-model="search"
        append-icon="search"
        clearable
        @click:clear="search = ''"
        hide-details
        key="classifications-search"
        label="Buscar una clasificación por nombre o id"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapMutations, mapState } = createNamespacedHelpers("matching");

export default {
  computed: {
    ...mapState(["classificationsSearch"]),
    search: {
      get() {
        return this.classificationsSearch;
      },
      set(value) {
        this.setClassificationsSearch(value);
      }
    }
  },
  methods: {
    ...mapMutations(["setClassificationsSearch"])
  }
};
</script>